import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WikiPanelService {
  readonly isOpen = signal(false);
  private readonly pendingTopicId = signal<string | null>(null);

  open(topicId?: string): void {
    if (topicId) {
      this.pendingTopicId.set(topicId);
    }
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }

  toggle(topicId?: string): void {
    if (this.isOpen()) {
      this.close();
      return;
    }
    this.open(topicId);
  }

  consumePendingTopic(): string | null {
    const topicId = this.pendingTopicId();
    this.pendingTopicId.set(null);
    return topicId;
  }
}
